var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5zM6.488 6.3c0-.27.218-.487.487-.487h4.05a.487.487 0 110 .974H9.637a2.513 2.513 0 01.478 1.05h.91a.487.487 0 110 .976h-.91a2.514 2.514 0 01-2.005 1.982l1.235 1.235a.487.487 0 11-.69.69L6.63 10.695a.488.488 0 01.345-.832h.675a1.537 1.537 0 001.458-1.05H6.975a.488.488 0 010-.976h2.133a1.54 1.54 0 00-1.458-1.05h-.675a.488.488 0 01-.487-.487z",
    fill: "#A4A4A4"
  })));
}

export default SvgPaymentCoin;